export default __webpack_public_path__ + "static/media/258.c60b1e64.png";